export default "__VITE_ASSET__D4FicFc8__"